export class TableActionOptions {
    /** @type {String} */
    icon

    /** @type {Function} */
    click

    /** @type {Function} */
    hidden

    /** @type {Boolean} */
    separator
}

export class TableAction {
    /** @type {String} */
    label

    /** @type {String} */
    icon

    /** @type {Function} */
    click

    /** @type {Function} */
    hidden

    /** @type {Boolean} */
    separator

    /**
     * @param {String} label
     * @param {TableActionOptions} options 
     */
    constructor(label, options) {
        if (label == null) {
            this.separator = true
            return
        }

        this.label = label

        if (options) {
            this.icon = options.icon
            this.click = options.click
            this.hidden = options.hidden
        }
    }
}
